import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    WorksheetPageIndex,
    SprayWorksheetCalibration
} from 'services/worksheet/types';
import { makeSelectSprayWorksheetCalibrations } from './selectors';
import PrintSprayWorksheetCalibrationSection from './components/PrintSprayWorksheetCalibrationSection';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

interface ConnectedProps {
    calibrations: SprayWorksheetCalibration[];
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetCalibrationsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex, calibrations } = this.props;

        return (
            <React.Fragment>
                {calibrations.map(({ id }, index) => (
                    <PrintSprayWorksheetCalibrationSection
                        key={id}
                        pageIndex={pageIndex}
                        calibrationId={id}
                        calibrationIndex={index + 1}
                    />
                ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    calibrations: makeSelectSprayWorksheetCalibrations()
});

export default connect(mapStateToProps)(
    PrintSprayWorksheetCalibrationsComponent
);
